import {
    defineMessages,
} from 'react-intl'
import { getCustomFilters } from "./customFilters"

const messages = defineMessages({
    "most_used_filters": {
        id: "invoice.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
    "title": {
        id: "scheduling_page.events.listing.headers.title_label",
        defaultMessage: "Title",
    },

    "other_filters": {
        id: "invoice.listing.headers.other_filters",
        defaultMessage: "Other filters",
    },
    "product_related_filters": {
        id: "invoice.listing.headers.product_related_filters",
        defaultMessage: "Product related filters",
    },
    "product_id": {
        id: "invoice.listing.headers.product_id",
        defaultMessage: "Product",
    },
    "product_label": {
        id: "invoice.listing.headers.product_label",
        defaultMessage: "Product label",
    },
    "product_title": {
        id: "invoice.listing.headers.product_title",
        defaultMessage: "Product title",
    },
    "product_sku": {
        id: "invoice.listing.headers.product_sku",
        defaultMessage: "Product sku",
    },
    "location": {
        id: "invoice.listing.headers.location",
        defaultMessage: "Location",
    },
    "contact_firstname": {
        id: "invoice.listing.headers.contact_firstname",
        defaultMessage: "Contact first name",
    },
    "contact_lastname": {
        id: "invoice.listing.headers.contact_lastname",
        defaultMessage: "Contact last name",
    },
    "contact_organization_name": {
        id: "invoice.listing.headers.contact_organization_name",
        defaultMessage: "Contact organization name",
    },
    "contact_type": {
        id: "invoice.listing.headers.contact_type",
        defaultMessage: "Contact type",
    },
    "contact_phonenumber": {
        id: "invoice.listing.headers.contact_phonenumber",
        defaultMessage: "Contact phone number",
    },
    "contact_email": {
        id: "invoice.listing.headers.contact_email",
        defaultMessage: "Contact email",
    },
    "contact_name": {
        id: "invoice.listing.headers.contact_name",
        defaultMessage: "Contact name",
    },
    "contact_id": {
        id: "invoice.listing.headers.contact_id",
        defaultMessage: "Contact id",
    },
    "contact_related_filters": {
        id: "invoice.listing.headers.contact_related_filters",
        defaultMessage: "Contact related filters",
    },
    "sellerId": {
        id: "invoice.listing.headers.seller_id",
        defaultMessage: "User id",
    },
    "status_filter_placeholder": {
        id: 'invoice.listing.status_filter_placeholder',
        defaultMessage: 'Filter by status',
    },
    "status": {
        id: "invoice.listing.headers.status_label",
        defaultMessage: "Status",
    },
    "poNumber": {
        id: "invoice.listing.headers.po_number",
        defaultMessage: "Po Number",
    },
    "date_related_filters": {
        id: "invoice.listing.headers.date_related_filters",
        defaultMessage: "Date related filters",
    },
    "created_at": {
        id: 'invoice.listing.filters.date.created_at',
        defaultMessage: 'Created date',
    },
    "ordered_at": {
        id: "order.listing.headers.ordered_at_label",
        defaultMessage: 'Ordered at date',
    },
    "updated_at": {
        id: 'invoice.listing.filters.date.updated_at',
        defaultMessage: 'Updated date',
    },
    "order_id": {
        id: "order.listing.headers.order_id",
        defaultMessage: "Order id",
    },
    "row_custom_status": {
        id: "order.listing.headers.row_custom_status",
        defaultMessage: "Row custom status",
    },
    "product_default_vendor": {
        id: "item_report.default_vendor",
        defaultMessage: "Default Vendor",
    },
})

export const itemReportListTotals = []

export const itemReportFields = [
    'productTitle',
    'productTitleAnalyzed',
    'productTitleKeyword',
    'productTitleSort',
    'poNumber',
    'poNumberAnalyzed',
    'poNumberKeyword',
]

export const getItemReportFilters = function (context) {
    var filtersToUse =
        [
            {
                section: context.intl.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: 'userId',
                label: context.intl.formatMessage(messages["sellerId"]),
                filterMatch: 'sellerId',
                type: 'select',
                typeOfSelect: 'user-select',
                placeHolder: 'Select User',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'locationId',
                label: context.intl.formatMessage(messages["location"]),
                filterMatch: 'locationId',
                type: 'select',
                typeOfSelect: 'location-select',
                placeHolder: 'Select Location',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'statuses',
                label: context.intl.formatMessage(messages["status"]),
                type: 'select',
                filterMatch: 'customStatusId',
                typeOfSelect: 'order-status-select-item-report',
                placeHolder: context.intl.formatMessage(messages["status_filter_placeholder"]),
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "poNumber",
                label: context.intl.formatMessage(messages["poNumber"]),
                filterMatch: 'poNumberKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["product_related_filters"]),
            },
            {
                nameId: "productId",
                label: context.intl.formatMessage(messages["product_id"]),
                filterMatch: 'rows.id',
                filterMatchNotOneOf: 'rowsObject.id',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'product-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "productTitle",
                label: context.intl.formatMessage(messages["product_title"]),
                filterMatch: 'rows.title',
                filterMatchNot: 'rowsObject.title',
                type: 'text',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "productSku",
                label: context.intl.formatMessage(messages["product_sku"]),
                filterMatch: 'rows.sku',
                filterMatchNot: 'rowsObject.sku',
                type: 'text',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'is'
            },
            {

                nameId: "productLabel",
                label: context.intl.formatMessage(messages["product_label"]),
                filterMatch: 'rows.labelIds',
                filterMatchNotOneOf: 'rowsObject.labelIds',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'product-label-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "productDefaultVendor",
                label: context.intl.formatMessage(messages["product_default_vendor"]),
                filterMatch: 'rows.labelIds',
                filterMatchNotOneOf: 'rowsObject.labelIds',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'product-vendor-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },

            {
                section: context.intl.formatMessage(messages["date_related_filters"]),
            },

            {
                nameId: 'createdAt',
                label: context.intl.formatMessage(messages["created_at"]),
                filterMatch: 'orderCreatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'orderedAt',
                label: context.intl.formatMessage(messages["ordered_at"]),
                filterMatch: 'orderedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'orderUpdatedAt',
                label: context.intl.formatMessage(messages["updated_at"]),
                filterMatch: 'updatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },

            {
                section: context.intl.formatMessage(messages["contact_related_filters"]),
            },

            {
                nameId: 'contactId',
                label: context.intl.formatMessage(messages["contact_id"]),
                filterMatch: 'contactId',
                type: 'select',
                typeOfSelect: 'customer-select',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'name',
                label: context.intl.formatMessage(messages["contact_name"]),
                filterMatch: 'contact.name',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'firstName',
                label: context.intl.formatMessage(messages["contact_firstname"]),
                filterMatch: 'contact.firstNameKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'lastName',
                label: context.intl.formatMessage(messages["contact_lastname"]),
                filterMatch: 'contact.lastNameKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'organizationName',
                label: context.intl.formatMessage(messages["contact_organization_name"]),
                filterMatch: 'contact.organizationNameKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'contactType',
                label: context.intl.formatMessage(messages["contact_type"]),
                filterMatch: 'contact.type',
                type: 'select',
                typeOfSelect: 'contactType-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'phoneNumber',
                label: context.intl.formatMessage(messages["contact_phonenumber"]),
                filterMatch: 'contact.phoneNumberKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'email',
                label: context.intl.formatMessage(messages["contact_email"]),
                filterMatch: 'contact.emailKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },

            {
                section: context.intl.formatMessage(messages["other_filters"]),
            },

            {
                nameId: "identifier",
                label: context.intl.formatMessage(messages["order_id"]),
                filterMatch: 'orderIdentifier',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "rowCustomStatusId",
                label: context.intl.formatMessage(messages["row_custom_status"]),
                filterMatch: 'rowsObject.rowCustomStatusId',
                filterMatchNotOneOf: 'rowsObject.rowCustomStatusId',
                type: 'select',
                typeOfSelect: 'row-custom-status',
                placeHolder: 'Select row status',
                initialSelect: 'isOneOf'
            },
        ]

    return filtersToUse.concat(getCustomFilters(context, "orders"))
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/itemreportfilters.jsx